//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import FaqSection from '~/components/Articles/CommonComponents/FaqSection.vue';
import ContinueReadingButton from '~/components/Articles/CommonComponents/ContinueReadingButton.vue';
import SuggestedArticles from '~/components/Articles/CommonComponents/SuggestedArticles.vue';
import PrepFooter from '~/components/ReusableComponents/PrepFooter.vue';
import { slugify } from '~/services/utilityFunctions.js';
import { BLOG_TOPICS } from '~/constants/blogConstants';
import analyticEvents, { ANALYTIC_SOURCE_MODULES } from '~/services/analyticEvents';
import { ROUTES } from '~/constants/pageRoutes';
import { ACQUISITION_SOURCE_CTA } from '~/constants/authFlows';
import greDiagnosticTestMixin from '~/mixins/greDiagnosticTestMixin';

const ActivityNudge = () => import('../../ReusableComponents/ActivityNudge.vue');

export default {
    name: 'ArticleContent',
    components: {
        FaqSection,
        PrepFooter,
        ContinueReadingButton,
        SuggestedArticles,
        ActivityNudge
    },
    mixins: [greDiagnosticTestMixin],
    inject: ['blogTopic'],
    props: {
        articleContent: {
            type: String,
            default: ''
        },
        articleHeader: {
            type: String,
            default: 'Overview'
        },
        faqs: {
            type: Array,
            default: () => []
        },
        faqHeading: {
            type: String,
            default: null
        },
        isBlog: {
            type: Boolean,
            default: false
        },
        isArticleTruncated: {
            type: Boolean,
            default: false
        },
        relatedArticles: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            intersectionObserver: null,
            headingIDs: [],
            BLOG_TOPICS
        };
    },
    computed: {
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated'
        }),
        showActivityNudge() {
            const isGmatOrIeltsOrToeflArticle = [
                BLOG_TOPICS.GMAT,
                BLOG_TOPICS.IELTS,
                BLOG_TOPICS.TOEFL
            ].includes(this.blogTopic);

            const isGreArticleAndNotAuthenticated =
                !this.isAuthenticated && this.blogTopic === BLOG_TOPICS.GRE;

            return (
                (isGmatOrIeltsOrToeflArticle || isGreArticleAndNotAuthenticated) &&
                this.$device.isMobileOrTablet
            );
        },
        bannerHeading() {
            if (this.blogTopic === BLOG_TOPICS.IELTS) {
                return 'Fast-Track Your IELTS Prep';
            }
            if (this.blogTopic === BLOG_TOPICS.TOEFL) {
                return 'Your TOEFL Success Starts Here';
            }
            if (this.blogTopic === BLOG_TOPICS.GMAT) {
                if (this.isAuthenticated) {
                    return 'Join Live GMAT Classes Now!';
                }
                return 'Get GMAT Prepared with Yocket Prep';
            }
            if (this.blogTopic === BLOG_TOPICS.GRE && !this.isAuthenticated) {
                return 'How Ready Are You for GRE?';
            }
            return '';
        },
        bannerSubHeading() {
            if (this.blogTopic === BLOG_TOPICS.IELTS) {
                return 'Get step-by-step guidance for IELTS success';
            }
            if (this.blogTopic === BLOG_TOPICS.TOEFL) {
                return 'Get expert guidance for a top TOEFL score today';
            }
            if (this.blogTopic === BLOG_TOPICS.GMAT) {
                if (this.isAuthenticated) {
                    return 'Live expert-led GMAT prep—study smarter, score higher';
                }
                return 'Prepare smarter, not harder, with Yocket Prep';
            }
            if (this.blogTopic === BLOG_TOPICS.GRE && !this.isAuthenticated) {
                return 'Take a free GRE test and get a performance report!';
            }
            return '';
        },
        bannerCtaText() {
            if (this.blogTopic === BLOG_TOPICS.IELTS) {
                return 'Talk to an Expert';
            }
            if (this.blogTopic === BLOG_TOPICS.TOEFL) {
                return 'Book a Free Call';
            }
            if (this.blogTopic === BLOG_TOPICS.GMAT) {
                if (this.isAuthenticated) {
                    return 'Book A demo';
                }
                return 'Signup on Yocket Prep Now';
            }
            if (this.blogTopic === BLOG_TOPICS.GRE && !this.isAuthenticated) {
                return 'Start Free Mock Test';
            }
            return '';
        }
    },
    watch: {
        articleContent() {
            // Whenever the article content changes, reset the observer to observe the new headings in view
            // Timeout is taken to let the new content to render the dom so that all of the new h2 can be obtained
            setTimeout(() => {
                this.stopObserving();
                this.startObserving();
            }, 500);
        }
    },
    mounted() {
        this.startObserving();
    },
    beforeDestroy() {
        this.stopObserving();
    },
    methods: {
        slugify,
        startObserving() {
            this.setObserver();
            const headings = document.querySelectorAll('h2');
            headings.forEach((ele) => {
                this.intersectionObserver.observe(ele);
            });
        },
        stopObserving() {
            if (this.intersectionObserver !== null) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = null;
            }
        },
        setObserver() {
            // Intersection Observer API will change the route.
            this.intersectionObserver = new IntersectionObserver(
                (entries) => {
                    const element = entries[0];
                    const hashRedirection = element.target.id;
                    if (hashRedirection) {
                        this.$emit('selectedContent', hashRedirection);
                    }
                },
                {
                    rootMargin: '-20% 0px -50% 0px'
                }
            );
        },
        ctaFunction() {
            this.$store.dispatch('analytics/trackEvent', {
                event: analyticEvents.guide_hook_clicked,
                data: {
                    guide_name: this.blogTopic.toUpperCase(),
                    blog_url: `${window.location.origin}${this.$route.path}`
                }
            });
            if (this.blogTopic === BLOG_TOPICS.IELTS || this.blogTopic === BLOG_TOPICS.TOEFL) {
                window.open(ROUTES.IELTS_TOEFL_DEMO, '_blank');
            } else if (this.blogTopic === BLOG_TOPICS.GMAT) {
                if (this.isAuthenticated) {
                    window.open(ROUTES.GMAT_BOOK_DEMO, '_blank');
                } else {
                    this.$store.commit(
                        'auth/setSignupCtaSource',
                        this.isBlog
                            ? ACQUISITION_SOURCE_CTA.gmat_blog_signup
                            : ACQUISITION_SOURCE_CTA.gmat_guide_signup
                    );
                    this.$router.push({
                        path: ROUTES.LOGIN,
                        query: { tab: 'signup' }
                    });
                }
            } else if (this.blogTopic === BLOG_TOPICS.GRE && !this.isAuthenticated) {
                this.takeGreDiagnosticTest(ANALYTIC_SOURCE_MODULES.BLOGS_GUIDES);
            }
        }
    }
};
